
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Button, Card, Container, Dialog, MenuItem, Paper } from '@mui/material';
import { useEffect, useState } from 'react';
import apiCNP from '../../../../services/apiCNP';
import api from '../../../../services/api';
import HeaderSession from '../../../../utils/headerSession';
import InputDocUpload from '../../../../utils/inputFileUpload/inputDocUpload';
import MessageSuccess from '../../../../messages/messageSuccess';
import MessageError from '../../../../messages/messageError';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Typography, TextField } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import ButtonLeft from '../../../../utils/buttonLeft';
import { useSelector } from 'react-redux';
import AlertEdit from '../../../../utils/alertEdit';
// import compressImage from '../../../../../../services/compressImage';


const useStyles = makeStyles({
    gridItem: { margin: 8 }
})

export default function FormSolicitacaoNumeroImportador() {
    const classes = useStyles()
    const [importador, setImportador] = useState('')
    const [municipios, setMunicipios] = useState([]);
    const [provincias, setProvincias] = useState([]);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const navigate = useNavigate()
    const definicoesSistema = useSelector((state) => state.definicoesSistema.data);
    // const user = useSelector(state => state.account.user);


    useEffect(() => {

        // VERIFICAR SE O SERVIÇO ESTA HABILITADO
        if (definicoesSistema?.servicos.includes('solicitarNumeroDeImportador')) {
        } else { navigate(-1) }


        apiCNP.get('/provincias')
            .then(res => {
                setProvincias(res.data.provincias);
            })
            .catch(err => '')

        importador?.provinciaId &&
            apiCNP.get(`/municipios-by-provincia/${importador?.provinciaId}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                })
                .catch(err => '')
    }, [importador?.provinciaI, definicoesSistema])

    async function HandleChangeFile(file, name) {
        setImportador((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }

    async function HandleChange(e) {
        // await compressImage(e.target.files[0])
        e.target.files ?
            setImportador((prevCadastro) => ({ ...prevCadastro, [e.target.name]: e.target.files[0] }))
            :
            setImportador((prevCadastro) => ({ ...prevCadastro, [e.target.name]: e.target.value }))

        if (e.target.name === 'provinciaId') {

            setImportador((prevCadastro) => ({ ...prevCadastro, municipio: '' }));
            await apiCNP.get(`/municipios-by-provincia/${e.target.value}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                    setImportador((prevCadastro) => ({ ...prevCadastro, provincia: res.data.provincia.designacao }));
                })
                .catch(err => '')
        }
    }

    async function createImportador() {

        const formData = new FormData();
        formData.append('foto', importador?.foto ?? '');
        formData.append('nome', importador?.nome ?? '');
        formData.append('numeroIdentificacao', importador?.numeroIdentificacao ?? '');
        formData.append('email', importador?.email ?? '');
        formData.append('tel1', importador?.tel1 ?? '');
        formData.append('provincia', importador?.provincia ?? '');
        formData.append('municipio', importador?.municipio ?? '');
        formData.append('bairro', importador?.bairro ?? '');
        formData.append('rua', importador?.rua ?? '');
        formData.append('copiaDI', importador?.documentoIdentificacao ?? '');

        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/importador/register', formData)
            .then(res => {
                // console.log(res)
                setMessageSuccess(res.data)

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message)
            }).finally(() => setLoad(false))
    }

    return (
        <Container style={{ minHeight: '70vh' }}>
            <HeaderSession title={'SOLICITAR DECLARAÇÃO DE DESALFANDEGAMENTO'} />
            <AlertEdit texto={'Use este seviço apenas se não tens não tens uma Autorização de Importação!'} />

            {messageSuccess && <MessageSuccess message={messageSuccess.msg} />}
            {messageError && < MessageError message={messageError} />}

            {!messageSuccess &&
                <Card sx={{ padding: 2 }}>
                    <Grid container alignItems='flex-end' >
                        <Grid xs={12} md={2} item className={classes.gridItem} >
                            <Paper style={{ border: '1px dashed #3e3d3f', textAlign: 'center' }}>
                                <label htmlFor="foto" style={{ cursor: 'pointer', textAlign: 'center' }}>
                                    <Avatar style={{ width: '100%', height: 150 }} variant="square" src={importador?.foto ? URL.createObjectURL(importador.foto) : '/img/avatar/avatarRepresentante.svg'} title="Clique para carregar uma imagem" />
                                    <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="foto" style={{ display: 'none' }} onChange={HandleChange} />
                                </label>
                                <small>Carregar imagem</small>
                            </Paper>
                        </Grid>
                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                type="text"
                                label="Nome "
                                fullWidth
                                size="small"
                                name="nome"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.nome}
                            />
                        </Grid>

                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                required
                                type="text"
                                label="Nº de identifição (ex: BI ou NIF)"
                                fullWidth
                                size="small"
                                name="numeroIdentificacao"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.numeroIdentificacao}
                            />
                        </Grid>
                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                type="text"
                                label="Contacto "
                                fullWidth
                                size="small"
                                name="tel1"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.contacto}
                            />
                        </Grid>

                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                type="email"
                                label="E-mail "
                                fullWidth
                                size="small"
                                name="email"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.email}
                            />
                        </Grid>
                    </Grid>


                    <Grid container >
                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                required
                                type="text"
                                label="Províncía"
                                select
                                fullWidth
                                size="small"
                                name="provinciaId"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.provinciaId ?? ''}
                            >
                                <MenuItem disabled value=''>Selecione Províncía</MenuItem>
                                {provincias?.map((provincia) => (
                                    <MenuItem key={provincia._id} value={provincia._id}>
                                        {provincia.designacao}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>

                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                disabled={!importador?.provinciaId}
                                required
                                type="text"
                                label="Município"
                                select
                                fullWidth
                                size="small"
                                name="municipio"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.municipio ?? ''}
                            >
                                <MenuItem disabled value=''>Selecione Município</MenuItem>
                                {municipios?.map((municipio) => (
                                    <MenuItem key={municipio._id} value={municipio.designacao}>
                                        {municipio.designacao}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                required
                                type="text"
                                label="Bairro"
                                fullWidth
                                size="small"
                                name="bairro"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.bairro}
                            />
                        </Grid>

                        <Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                required
                                type="text"
                                label="Rua"
                                fullWidth
                                size="small"
                                name="rua"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={importador?.rua}
                            />
                        </Grid>
                    </Grid>

                    <br />
                    {/* ANEXO DE DOCUMENTOS */}
                    <InputDocUpload
                        imputLigth={true}
                        fullWidth={true}
                        onFileSelect={HandleChangeFile}
                        inputName={'documentoIdentificacao'}
                        inputTitle={'Carregar aquí a cópia colorida do documento de identificação'} />

                    <ButtonLeft
                        load={load}
                        title={'Submeter'}
                        funcao={createImportador}
                        disabled={!importador?.documentoIdentificacao || load} />
                </Card>
            }

            {messageSuccess &&
                <Dialog open={true} fullWidth>
                    <Typography style={{ margin: 20 }} align="center">
                        <CheckCircleOutlineIcon fontSize="large" color="success" />
                        <br />
                        {messageSuccess.msg}
                    </Typography>

                    <Typography style={{ margin: 20, marginBottom: 30 }} >
                        Dados da Solicitação:
                        <br />
                        Proprietário(a) da Declaração: <strong>{messageSuccess.importador?.nome}</strong>
                        <br />
                        Número: <strong>{messageSuccess.importador?.numeroAutorizacao}</strong>
                        <br />
                        <br />
                        <strong>OBS:</strong> Foi enviado estes dados para o seu endereço de email.
                    </Typography>

                    <Button onClick={() => navigate('/inspeccao-regulatoria')}>Inspecção Regulatória</Button>
                </Dialog>
            }
        </Container>
    )
}
